import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Checkbox, FormGroup } from 'react-bootstrap';

export default class CheckboxGroup extends React.Component {
    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);
    }

    handleChange(evt) {
        const { value } = this.props;
        const pos = value.indexOf(evt.target.name);
        const args = pos < 0 ? [value.length, 1, evt.target.name] : [pos, 1];
        value.splice(...args);
        if (this.props.onChange) {
            this.props.onChange(evt, this.props.value);
        }
    }

    render() {
        const { value, name } = this.props;
        const classNames = classnames('checkbox-group', this.props.className);

        return (
            <FormGroup className={classNames} name={name}>
                {this.props.options.map((option, idx) => {
                    return (
                        <Checkbox
                            key={`checkbox-group-input-${idx}`}
                            value={value.find(val => val === option.value)}
                            name={option.value}
                            disabled={option.disable}
                            onChange={this.handleChange}
                            checked={value.includes(option.value)}
                            data-option-key={option.key}
                            data-option-text={option.text}
                        >
                            <div>
                                {option.label}
                                {option.tooltip && this.props.renderTooltip(option, idx)}
                            </div>
                        </Checkbox>
                    );
                })}
            </FormGroup>
        );
    }
}

CheckboxGroup.propTypes = {
    /**
     * The name of the checkbox group.
     *
     * Also used as part of unique id in tooltip
     */
    name: PropTypes.string.isRequired,
    /**
     * Array of checkbox button options: { label: 'optionLabel', value: 'optionValue' }
     */
    options: PropTypes.arrayOf(PropTypes.object).isRequired,
    /**
     * Value of the selected radio button
     */
    value: PropTypes.array,
    /**
     * @function onChange Callback fired when a radio button is selected.
     *
     * @param {Object} event The event source of the callback. You can access the value by accessing event.target.value.
     * @param {String} value The value of the selected radio button.
     * @returns void
     *
     */
    onChange: PropTypes.func,
    /**
     * @function renderTooltip Func. that renders additional inf. about option.
     *
     * @returns Component
     */
    renderTooltip: PropTypes.func
};
